<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
    v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important' }"
  >
    <img :src="ingresoLogo.imagen" id="logo" v-bind:style="logoStyle" />
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg pb-8">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-10">
                  <h4 class="mb-4">Cambiar Clave</h4>
                  <p>Por políticas de seguridad es necesario que actualices tu clave.</p>
                </div>
                <ChangePasswordForm :isUpdateBySystem="true"/>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import ChangePasswordForm from '@/febos/global/usuario/components/ChangePasswordForm';

export default {
  mixins: [I18nMixin, PersonalizacionMixin],
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      recordar: false,
      keyRecordar: `${process.env.VUE_APP_CODIGO_PAIS}.${process.env.VUE_APP_PORTAL}.${process.env.VUE_APP_AMBIENTE}.correo`
    };
  },
  mounted() {
    if (localStorage.getItem(this.keyRecordar)) {
      this.correo = localStorage.getItem(this.keyRecordar);
      if (this.correo !== '') {
        this.recordar = true;
      }
    }
    this.attemptLoadSettings();
  },
  components: {
    ChangePasswordForm
  },
  methods: {
  }
};
</script>

<style lang="scss">

</style>
